import './App.css';
import smile from './smile.png';
import share from './share.png'
import profilePic from './profile_pic.png';
import { FacebookShareButton } from "react-share";
import NavBar from './NavBar';
import { Outlet } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Overlock:ital,wght@0,400;0,700;0,900;1,400;1,700;1,900&display=swap');
      </style>
      <div className='App-header-panel'>
        <div className='App-header App-header-height'>
          <div className='App-header-text'>
            <span>
              Prywatna Praktyka<br />Stomatologiczna <br />Paweł Barucha
            </span>
            <img src={smile} className='App-header-image' alt={'smile'} />
          </div>
          <div className='App-header-contact-panel App-header-contact-panel-size'>
            <div className='App-header-contact'>
              Kontakt:<strong style={{ marginLeft: '5px' }}>606 833 234</strong> <br/>
            </div>
            Poniedziałek-środa: 14-19
            <FacebookShareButton url='pablodent.pl'>
              <img src={share} className='App-header-image' alt={'share'} />
            </FacebookShareButton>
          </div>
        </div>
      </div>
      <NavBar />
      <div className='App-body'>
        <Outlet />
      </div>
      <div className='App-footer'>
        <div className='App-footer-panel'>
          <div className='App-footer-item App-footer-item-size'>
            <div className='App-footer-headline'>
              O mnie
            </div>
            <div>
              lek. dent. Paweł Barucha
            </div>
            <img src={profilePic} alt="" className='App-footer-image' />
            <div className='App-footer-copyright'>
              © Prawa autorskie Paweł Barucha 2016-2025
              <br />
              Strona nie stanowi oferty handlowej
            </div>
          </div>
          <div className='App-footer-item App-footer-item-size'>
            <div className='App-footer-headline'>
              Kontakt
            </div>
            <div>
              Stanisława Wyspiańskiego 1/36 <br />
              25-409 Kielce <br />
              Telefon: 606 833 234
            </div>
          </div>
          <div className='App-footer-item App-footer-item-size'>
            <div className='App-footer-headline'>
              Dojazd
            </div>
            <div>
              <iframe title='dojazd' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2517.0227953150365!2d20.641636776870698!3d50.88628845588673!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4718270350daafdd%3A0xe97c2a01efc9f78e!2sStanis%C5%82awa%20Wyspia%C5%84skiego%201%2C%2025-409%20Kielce!5e0!3m2!1spl!2spl!4v1736875924618!5m2!1spl!2spl" className='App-footer-map ' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
